// O pipeline usa o sentinela "0" como creditor_name quando o título vem de um
// movimento bancário sem fornecedor identificado (sem conta a pagar vinculada no
// Sienge). Na exibição, troca esse "0" por um rótulo claro para o usuário.
export const BANK_MOVEMENT_CREDITOR_LABEL = "Títulos de movimentação bancária";

export const formatCreditorName = (creditorName) =>
  creditorName === "0" ? BANK_MOVEMENT_CREDITOR_LABEL : creditorName;
